export default __webpack_public_path__ + "static/person-1eeb8255f1662cf3d1e85276e7acc74b.svg";